export const OFFERING_IMAGES = {
    cloud: 'cloudImage',
    multitier: 'multiTier',
    helm: 'helmChart',
    containers: 'container',
    'virtual-machine': 'virtualMachine'
};

export const formatToLowerCase = (input) => {
    return input
    .toLowerCase()
    .replace(/\(.*?\)|[^a-zA-Z0-9\s]/g, '')  
    .replace(/\s+/g, '-');
};

export const resolveTransforms = (textValue) => {
    if (!textValue) return '';

    let utf8Value = textValue;

    // Converting sequences (TM) and (R) into the TM and (R) characters respectively.
    utf8Value = utf8Value.replace(/\(TM\)/g, '\u2122');
    utf8Value = utf8Value.replace(/\(R\)/g, '\u00AE');

    return utf8Value;
};

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    }).format(date);
};